import React, { useState } from "react";
import { connect } from "react-redux";
import { Button, Div, Input, Panel, PanelHeader, Text } from "@vkontakte/vkui";
import styles from "./OMSPanel.style";
import Header from "../Header";
import { userInfoLoadingSuccess } from "../../redux/actions/userInfoActions";
import { restartPanelsHistory } from "../../redux/actions/panelsActions";
import UserAvatar from "../UserAvatar";
import { setEnteredOms } from "../../redux/actions/omsActions";
import {setActiveAlert} from "../../redux/actions/alertsActions";
import ConfirmLogoutAlert from "../../alerts/ConfirmLogoutAlert";
import HeaderWithLogout from "../../components/HeaderWithLogout/HeaderWithLogout";

const isValidOms = (oms) => {
  if (!oms) {
    return false;
  }
  if (!oms.match(/(^\d{16}$)|(^\d{6} \d{10}$)/)) {
    return false;
  }
  return true;
};

const OMSPanel = ({
  id,
  userInfo,
  setUserInfo,
  goToEqueuesPanel,
  saveEnteredOms,
  activePanel,
}) => {
  const [omsValue, setOmsValue] = useState("");
  const onOmsInputChange = (e) => {
    setOmsValue(e.target.value);
  };

  const onSaveButtonClick = () => {
    const updatedUserInfo = { ...userInfo };
    const findCandidateIndex = updatedUserInfo.person.docs.findIndex(x => x.type === "MDCL_PLCY")

    if (findCandidateIndex >= 0) {
      updatedUserInfo.person.docs[findCandidateIndex].number = omsValue
    } else {
      updatedUserInfo.person.docs.push({
        type: "MDCL_PLCY",
        number: omsValue,
      });
    }

    setUserInfo(updatedUserInfo);
    goToEqueuesPanel();
    saveEnteredOms(omsValue);
  };

  return (
    <Panel id={id}>
      <PanelHeader
        separator={false}
        left={
          <Div
            style={{
              display: "flex",
              padding: "0",
            }}
          >
            <HeaderWithLogout />
          </Div>
        }
      ></PanelHeader>

      <Text style={styles.warningMessage}>
        Для записи к врачу необходимо добавить данные полиса ОМС
      </Text>
      <Text style={styles.inputLabel}>Номер полиса</Text>
      <Div style={styles.inputWrapper}>
        <Input onChange={onOmsInputChange} maxLength={17} autoFocus />
      </Div>
      <Text style={styles.infoMessage}>
        Если полис содержит серию и номер, введите сначала серию потом номер
        через пробел
      </Text>
      <Button
        style={styles.saveButton}
        disabled={!isValidOms(omsValue)}
        onClick={onSaveButtonClick}
      >
        Сохранить
      </Button>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo.userInfo,
    activePanel: state.panels.activePanel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserInfo: (userInfo) => dispatch(userInfoLoadingSuccess(userInfo)),
    goToEqueuesPanel: () => dispatch(restartPanelsHistory()),
    saveEnteredOms: (enteredOms) => dispatch(setEnteredOms(enteredOms)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OMSPanel);
